// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"362":"64fa3157","413":"bc3c6564","623":"a2823553","702":"7bceaa78","787":"23487216"}[chunkId] + ".chunk.js";
};